<template>
	<v-card v-if='files && files.length' class="my-4 opaqueBg02" :elevation='flat ? 0 : 10' rounded >

			<v-card-text class='font-weight-light text-uppercase pb-0'>
				<!-- text-h5 -->
				<b>Documents</b>
			</v-card-text>

		<v-card-text class='pt-0'>
			<v-row>
				<v-col
					:key="index"
					cols="auto"
					style="min-width: 200px"
					v-for="(file, index) in files"
				>
					<FileItem v-bind="file" @click.native="openFile(file.path)" />
				</v-col>
			</v-row>
		</v-card-text>
	
	</v-card>
</template>

<script>
import FileItem from '@/components/n-collections/n-items/FileItem'
import CONFIG from '@/config'

export default {
	name: 'AttachmentSection',
	components: {
		FileItem,
	},
	props: {
		files: Array,
		flat: Boolean
	},
	methods: {
		openFile(path) {
			window.open(path, '_blank')
		},
	},
}
</script>